"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectInput = exports.colourStyles = void 0;
const core_1 = require("@material-ui/core");
const web_elements_assets_1 = require("@mindee/web-elements.assets");
const react_1 = __importDefault(require("react"));
const react_select_1 = __importDefault(require("react-select"));
const classnames_1 = __importDefault(require("classnames"));
exports.colourStyles = {
    container: (styles) => (Object.assign(Object.assign({}, styles), { width: "100%", "&:hover": {
            boxShadow: "none",
        } })),
    control: (styles) => (Object.assign(Object.assign({}, styles), { minHeight: "3rem", borderColor: web_elements_assets_1.COLORS.border })),
    menu: (styles) => (Object.assign(Object.assign({}, styles), { zIndex: 10 })),
    valueContainer: (styles) => (Object.assign(Object.assign({}, styles), { fontFamily: web_elements_assets_1.FONTS.regular })),
    indicatorSeparator: () => ({ display: "none" }),
    multiValue: (styles) => (Object.assign(Object.assign({}, styles), { color: web_elements_assets_1.COLORS.white, background: web_elements_assets_1.COLORS.blue, borderRadius: 4 })),
    multiValueLabel: (styles) => (Object.assign(Object.assign({}, styles), { color: web_elements_assets_1.COLORS.white })),
};
const useStyles = core_1.makeStyles((theme) => ({
    error: {
        height: 10,
        fontSize: 10,
    },
    caption: { fontSize: 10 },
    label: {
        "&:after": {
            content: ({ required }) => required ? '" *"' : "",
            color: theme.palette.primary.main,
        },
    },
}));
function SelectInput(_a) {
    var { classes: customClasses = {}, multiple = false, required = false, id, label, caption, className = "select-input", error, disabled = false, hideError = false, style = {} } = _a, props = __rest(_a, ["classes", "multiple", "required", "id", "label", "caption", "className", "error", "disabled", "hideError", "style"]);
    const classes = useStyles({ required });
    return (react_1.default.createElement(core_1.Box, { height: "100%", width: "100%", style: style, display: "flex", flexDirection: "column", className: className },
        label && (react_1.default.createElement(core_1.Typography, { className: classnames_1.default(classes.label, {
                [customClasses.label]: !!customClasses.label,
            }), variant: "body1" }, label)),
        react_1.default.createElement(react_select_1.default, Object.assign({ "data-testid": "select-input", isDisabled: disabled, id: id }, props, { isMulti: multiple, styles: exports.colourStyles })),
        caption && (react_1.default.createElement(core_1.Typography, { className: classes.caption, variant: "caption" }, caption)),
        !hideError && (react_1.default.createElement(core_1.Typography, { color: "error", className: classes.error, variant: "caption" }, error))));
}
exports.SelectInput = SelectInput;
//# sourceMappingURL=select-input.js.map